import { jsx, jsxs } from "react/jsx-runtime";
import { Form, Box, Combobox, Input, Button } from "@zillow/constellation-10";
import React from "react";
function assertSearchType(value) {
  if (value === "installation") {
    return;
  }
  if (value !== "zip" && value !== "installations") {
    throw new Error(`Invalid search type: "${value}". Expected 'zip' or 'installations'.`);
  }
}
const normalizeSearchType = (value) => {
  if (value === "installation") {
    return "installations";
  }
  assertSearchType(value);
  return value;
};
const AgentSearch = ({
  placeholder,
  search = "zip",
  disabled
}) => {
  const normalizedSearch = normalizeSearchType(search);
  const zipRef = React.useRef("");
  const handleSelectChange = (item) => {
    if (normalizedSearch === "installations" && item) {
      const installation = INSTALLATIONS.find((inst) => inst[0] === item);
      if (installation) {
        zipRef.current = installation[1];
      }
    }
  };
  const handleSubmit = (event) => {
    event.preventDefault();
    const form = event.target;
    const url = "https://www.zillow.com/professionals/relocation--real-estate-agent-reviews/" + zipRef.current;
    form.action = url;
    form.submit();
  };
  const INSTALLATIONS = [["Fort Novosel", "36362"], ["Portsmouth Naval Shipyard", "03904"], ["Camp Pendleton", "92055"]];
  const INSTALLATIONS_NAMES = INSTALLATIONS.map((inst) => inst[0]);
  return /* @__PURE__ */ jsx(Form, { onSubmit: handleSubmit, target: "_blank", children: /* @__PURE__ */ jsxs(Box, { css: {
    display: "flex",
    flexDirection: "column"
  }, children: [
    normalizedSearch === "installations" ? /* @__PURE__ */ jsx(Combobox, { options: INSTALLATIONS_NAMES, placeholder, "aria-label": "installations", onChange: handleSelectChange, disabled: !!disabled }) : /* @__PURE__ */ jsx(Input, { type: "text", "aria-label": "zipcode", name: "zipcode", placeholder, disabled: !!disabled, onChange: (event) => zipRef.current = event.target.value }),
    /* @__PURE__ */ jsx(Button, { type: "submit", css: {
      width: "100%",
      marginTop: "loose"
    }, tone: "brand", emphasis: "filled", disabled: !!disabled, children: "Find an agent" })
  ] }) });
};
export {
  AgentSearch as default
};
